import { useNavigate } from 'react-router-dom';
import { api, errorMessage } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';
import { qk, queryClient } from '@/lib/queryClient';
import { useUi } from '@/lib/store';

export function useStartDm() {
  const ws = useWorkspaceId();
  const nav = useNavigate();
  const toast = useUi(s => s.toast);
  return async (userIds: string[]) => {
    if (!ws) return;
    try {
      const c = await api.openDm(ws, userIds);
      await queryClient.invalidateQueries({ queryKey: qk.conversations(ws) });
      nav(`/c/${c.id}`);
    } catch (e) { toast(errorMessage(e), 'error'); }
  };
}
